import { useEffect, useRef } from "react";

import { useAtomValue } from "jotai";

import { atomStudioData } from "../screens/Dashboard/SubComponents/Studio/Studio.atoms";

import { SceneSyncChannel } from "./sceneSync";

/**
 * Publica el modelo de escena vivo (`atomStudioData`) al OSR window por BroadcastChannel:
 * responde `request-scene` con el modelo actual y reemite en cada cambio. Vive en el
 * control window (dentro del Provider de Jotai). No tiene efecto en el OSR (ahí se monta
 * `BroadcastComposition`, no `<Root/>`).
 */
export const SceneSyncPublisher = (): null => {
  const model = useAtomValue(atomStudioData);

  const modelRef = useRef(model);
  modelRef.current = model;

  const channelRef = useRef<SceneSyncChannel | null>(null);

  useEffect(() => {
    const channel = new SceneSyncChannel();
    channelRef.current = channel;

    const off = channel.on((msg) => {
      if (msg.type === "request-scene" && modelRef.current) {
        try {
          channel.post({ type: "scene", model: modelRef.current });
        } catch (e) {
          console.warn(
            "[SceneSync] no se pudo publicar la escena (request):",
            e,
          );
        }
      }
    });

    return () => {
      off();
      channel.close();
      channelRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (model && channelRef.current) {
      try {
        channelRef.current.post({ type: "scene", model });
      } catch (e) {
        // p.ej. DataCloneError si el modelo trae algo no estructurado-clonable; no romper la app.
        console.warn("[SceneSync] no se pudo publicar la escena:", e);
      }
    }
  }, [model]);

  return null;
};
